import { apiFetch } from './apiClient';

export type SettingItem = {
  key: string;
  value?: string | null;
  defaultValue?: string | null;
  effectiveValue?: string | null;
  title?: string | null;
};

export const listSettings = (): Promise<SettingItem[]> => apiFetch('/settings');

export const updateSetting = (key: string, value: string | null): Promise<SettingItem> =>
  apiFetch(`/settings/${key}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ value }),
  });

const SettingService = { listSettings, updateSetting };
export default SettingService;
